module.exports = __webpack_public_path__ + "img/185.79c8bbdd.jpg";